import { MaintenancePanel } from "./MaintenancePanel";

export const MotoMaintenancePanel = () => (
  <MaintenancePanel type="moto" />
);
